import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "background-modal" }
const _hoisted_2 = { class: "wrapper-modal" }
const _hoisted_3 = { class: "wrapper-title" }
const _hoisted_4 = { class: "wrapper-create-sample" }
const _hoisted_5 = { class: "wrapper-form" }
const _hoisted_6 = { class: "wrapper-image" }
const _hoisted_7 = { class: "info" }
const _hoisted_8 = { class: "wrapper-reference-image" }
const _hoisted_9 = { class: "grid-image" }
const _hoisted_10 = ["src"]
const _hoisted_11 = ["src"]
const _hoisted_12 = {
  key: 2,
  class: "no-image"
}
const _hoisted_13 = {
  key: 0,
  class: "wrapper-secondary-images"
}
const _hoisted_14 = { class: "info" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { class: "secondary-images" }
const _hoisted_17 = { class: "secondary-info" }
const _hoisted_18 = { class: "secondary-buttons" }
const _hoisted_19 = ["src"]
const _hoisted_20 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CloseButton = _resolveComponent("CloseButton")!
  const _component_GeneralInput = _resolveComponent("GeneralInput")!
  const _component_SecondaryButton = _resolveComponent("SecondaryButton")!
  const _component_DeleteButton = _resolveComponent("DeleteButton")!
  const _component_EditButton = _resolveComponent("EditButton")!
  const _component_StandardButton = _resolveComponent("StandardButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[6] || (_cache[6] = _createElementVNode("p", { class: "title" }, "Referencia", -1)),
        _createVNode(_component_CloseButton, { onClick: _ctx.closeModal }, null, 8, ["onClick"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _cache[7] || (_cache[7] = _createElementVNode("p", null, "Información de la referencia", -1)),
          _createVNode(_component_GeneralInput, {
            text: _ctx.reference.val,
            "onUpdate:text": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.reference.val) = $event)),
            value: _ctx.reference.val,
            label: 'Referencia',
            "has-error": _ctx.reference.enabled,
            error: _ctx.reference.errors.length === 0 ? '' : _ctx.reference.errors[0],
            "is-disabled": _ctx.isEdit
          }, null, 8, ["text", "value", "has-error", "error", "is-disabled"]),
          _createVNode(_component_GeneralInput, {
            text: _ctx.description.val,
            "onUpdate:text": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.description.val) = $event)),
            value: _ctx.description.val,
            label: 'Descripción',
            "has-error": _ctx.description.enabled,
            error: 
              _ctx.description.errors.length === 0 ? '' : _ctx.description.errors[0]
            
          }, null, 8, ["text", "value", "has-error", "error"])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _cache[8] || (_cache[8] = _createElementVNode("p", null, "Imagen principal", -1)),
            _createVNode(_component_SecondaryButton, {
              buttonLabel: 'Subir imagen',
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$refs.fileImage.click()))
            }),
            _createElementVNode("input", {
              type: "file",
              ref: "fileImage",
              hidden: "",
              onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.uploadImage && _ctx.uploadImage(...args))),
              onClick: _cache[4] || (_cache[4] = ($event: any) => ($event.target.value = ''))
            }, null, 544)
          ]),
          _cache[9] || (_cache[9] = _createElementVNode("p", { class: "text" }, "La imagen debe tener una relación 1/1.", -1)),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("figure", _hoisted_9, [
              (_ctx.showImagePreview)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: _ctx.previewImage,
                    class: "cloth-image"
                  }, null, 8, _hoisted_10))
                : (_ctx.showImage)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 1,
                      src: _ctx.originalReference.main,
                      class: "cloth-image"
                    }, null, 8, _hoisted_11))
                  : (_openBlock(), _createElementBlock("p", _hoisted_12, "Sin imagen"))
            ]),
            (_ctx.showImagePreview)
              ? (_openBlock(), _createBlock(_component_DeleteButton, {
                  key: 0,
                  class: "delete",
                  onClick: _ctx.removeUploadImage
                }, null, 8, ["onClick"]))
              : _createCommentVNode("", true)
          ])
        ]),
        (_ctx.originalReference != null)
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _cache[10] || (_cache[10] = _createElementVNode("p", null, "Imágenes de la referencia para el inventario", -1)),
                _createVNode(_component_SecondaryButton, {
                  buttonLabel: 'Crear imagen para inventario',
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.inventoryImage(null, null)))
                })
              ]),
              (_ctx.originalReference?.additional != undefined)
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                    _createElementVNode("ul", _hoisted_16, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.originalReference.additional, (additional, index) => {
                        return (_openBlock(), _createElementBlock("li", {
                          class: "wrapper-images",
                          key: index
                        }, [
                          _createElementVNode("div", _hoisted_17, [
                            _cache[11] || (_cache[11] = _createElementVNode("p", null, "Imagen inventario", -1)),
                            _createElementVNode("div", _hoisted_18, [
                              _createVNode(_component_EditButton, {
                                onClick: ($event: any) => (_ctx.inventoryImage(additional, index))
                              }, null, 8, ["onClick"]),
                              _createVNode(_component_DeleteButton, {
                                onClick: ($event: any) => (_ctx.deleteSecondaryReference(index))
                              }, null, 8, ["onClick"])
                            ])
                          ]),
                          _createElementVNode("img", {
                            src: additional.slider,
                            alt: "",
                            class: "image-secondary"
                          }, null, 8, _hoisted_19),
                          _createElementVNode("img", {
                            src: additional.full,
                            alt: "",
                            class: "image-secondary"
                          }, null, 8, _hoisted_20)
                        ]))
                      }), 128))
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ]),
      _createVNode(_component_StandardButton, {
        buttonLabel: 'Guardar',
        class: "margin-button",
        "is-disabled": _ctx.disabledForm,
        onClick: _ctx.buildReference
      }, null, 8, ["is-disabled", "onClick"])
    ])
  ]))
}